// Development environment
export const environment = {
  production: false,
  name: 'sit',
  apiUrl: 'https://sit-ope-application-backend-124917071187.us-east4.run.app/api',
  allowedOrigins: [
    '*'
  ],
};
